// extracted by mini-css-extract-plugin
module.exports = {"title":"Highlights_title__3BLeq","killBlurb":"Highlights_killBlurb__3D4wL","feedContainer":"Highlights_feedContainer__3Qu2n"};